import { CertifiedPublisherPropsMicrocopy } from '../../molecules/CertifiedPublisher/CertifiedPublisher.types';
import {
  ReviewStarsPropsData,
  ReviewStarsPropsMicrocopy,
} from '../../molecules/ReviewStars/ReviewStars.types';
import {
  ProductPricingAddToCartProps,
  ProductPricingProps,
  ProductPricingPropsActions,
  ProductPricingPropsData,
  ProductPricingPropsMicrocopy,
} from '../ProductPricing/ProductPricing.types';

export const ProductInfoBadgeOptions = {
  Upm: 'upm',
  VerifiedSolutions: 'verifiedSolutions',
  Deprecated: 'deprecated',
} as const;

export type ProductInfoBadgeType =
  (typeof ProductInfoBadgeOptions)[keyof typeof ProductInfoBadgeOptions];

export type ProductInfoPropsMicrocopy = ProductPricingPropsMicrocopy & {
  reviewStars?: ReviewStarsPropsMicrocopy;
  verifiedSolutions?: {
    text?: string;
    tooltip: {
      title?: string;
      benefit1?: string;
      benefit2?: string;
      benefit3?: string;
      cta?: string;
    };
  };
  certifiedPublisher: CertifiedPublisherPropsMicrocopy;
  verifiedOrganization: string;
  verifiedIndividual: string;
};

export type ProductInfoPropsData = ProductPricingPropsData & {
  type: 'single-package' | 'multi-package';
  isVerifiedSolution?: boolean;
  publisherName: string;
  publisherLink: string;
  isCertifiedPublisher: boolean;
  publisherAccountType?: 'organization' | 'individual';
  publisherAvatarUrl?: string;
  productTitle: string;
  reviews?: ReviewStarsPropsData;
  isReviewsEnabled?: boolean;
};

export type ProductInfoPropsDataWithMicrocopy = ProductInfoPropsData & {
  microcopy: ProductInfoPropsMicrocopy;
};

export type ProductInfoPropsActions = ProductPricingPropsActions;

export type ProductInfoProps = Omit<
  ProductInfoPropsDataWithMicrocopy & ProductPricingPropsActions,
  'isAddToCartEnabled' | 'onAddToCart'
> &
  ProductPricingAddToCartProps & {
    variant?: 'default' | 'sticky';
    quantity?: ProductPricingProps['quantity'];
    onQuantityChange?: ProductPricingProps['onQuantityChange'];
    className?: string;
  };
